import style from "../../index.module.scss";
import { Button } from "antd";
import React from "react";
import { PaperExportModal } from "./Components/PaperExportModal";
import useRequest from "../../../../../utils/useRequest";
import { date2WeekHanzi, getCourseData } from "../../../../../service/service";
import useModalHandler from "../../../../../utils/v3/useModalHandler";

interface DownloadBtnProps {
    weekTimeId: string;
    data: PaperData[];
}

export function DownloadBtn({ weekTimeId, data }: DownloadBtnProps) {
    const modal = useModalHandler();
    const [CourseData] = useRequest(() => getCourseData({}));

    const course = CourseData?.find(
        item => String(item.weekTimeId) === weekTimeId
    );

    return (
        <>
            <Button type="primary" className={style.btn} onClick={modal.open}>
                打包全部作业附件
            </Button>

            {modal.render(
                <PaperExportModal
                    name={`${course?.courseName} ${course?.courseSeq} 第${
                        course?.week
                    }周 ${date2WeekHanzi(course?.date || "")} ${course?.date}`}
                    data={data}
                />
            )}
        </>
    );
}
